import { render, staticRenderFns } from "./Robot.vue?vue&type=template&id=6cd0264d&scoped=true&"
import script from "./Robot.vue?vue&type=script&lang=ts&"
export * from "./Robot.vue?vue&type=script&lang=ts&"
import style0 from "./Robot.vue?vue&type=style&index=0&id=6cd0264d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd0264d",
  null
  
)

export default component.exports